import React, { useEffect, useState } from "react";
import { useChatState } from "../../state/ChatState";
import { useScript } from "../../../hooks/useScript";

export const DFXiaomiVoiceOverlay = ({
	agentId,
	text = "How can I {{assist}} you today?",
}: {
	agentId?: string;
	text?: string;
}) => {
	const chatState = useChatState(); // global state
	const [isMicActive, setIsMicActive] = useState(false);

	useEffect(() => {
		window.symantoAgentTester.setupCanvas();
	}, []);

	useEffect(() => {
		if (isMicActive && agentId) {
			window.symantoAgentTester.startConversation(
				agentId,
				chatState.baseConfig!.API_KEY,
				chatState.baseConfig!.BASE_API_URL,
			);
		} else {
			window.symantoAgentTester.stopConversation();
		}
	}, [isMicActive]);

	useEffect(() => {
		window.symantoAgentTester.stopConversation();
		setIsMicActive(false);
		chatState.resetMessages();
	}, [agentId]);

	const toggleMic = () => {
		if (agentId) {
			setIsMicActive(!isMicActive);
		} else {
			alert("Please select an agent first");
		}
	};

	return (
		<>
			<h1
				className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-medium text-gray-800 text-center mb-6 sm:mb-8 lg:mb-12 font-semibold landscape:sm:w-[70%] landscape:lg:w-[100%] landscape:sm:mb-0"
				dangerouslySetInnerHTML={{
					__html: text
						.replace("{{", '<span style="color: #56a7e2; font-weight: bold;">')
						.replace("}}", "</span>"),
				}}
			></h1>
			{/* AI Avatar/Logo */}
			<div className="relative">
				<div
					className="relative w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 
                              rounded-full  flex justify-center items-center "
				>
					<canvas id="waveCallCanvas" width="auto" height="auto"></canvas>
					<div
						className="absolute animate-none btn-circle z-10"
						onClick={() => toggleMic()}
					>
						<div className="bg-white rounded-full p-2">
							{isMicActive === false && (
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width={32}
									height={32}
									viewBox="0 0 24 24"
								>
									<path
										fill="#000"
										d="M8 17.175V6.825q0-.425.3-.713t.7-.287q.125 0 .263.037t.262.113l8.15 5.175q.225.15.338.375t.112.475t-.112.475t-.338.375l-8.15 5.175q-.125.075-.262.113T9 18.175q-.4 0-.7-.288t-.3-.712"
									></path>
								</svg>
							)}
							{isMicActive === true && (
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width={32}
									height={32}
									viewBox="0 0 24 24"
								>
									<path
										fill="#000"
										d="M6 16V8q0-.825.588-1.412T8 6h8q.825 0 1.413.588T18 8v8q0 .825-.587 1.413T16 18H8q-.825 0-1.412-.587T6 16"
									></path>
								</svg>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
